module.exports = __webpack_public_path__ + "static/media/sidebar-logout-selected.e3d2c38f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-logout-selected.svg
// module id = 800
// module chunks = 0